<v2-card
  (click)="$event.stopPropagation()"
  [class.slide-out]="slideOutCommenced"
  [flatBottom]="true"
>
  <div id="insertion-cont" (scroll)="onContentScroll($event)">
    <ng-template componentInsertion></ng-template>
  </div>
</v2-card>
